// Firebase Configuration for TradeRelax
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyCuYEdOM-6XOt1pEpNdA7YchYuREQyw2wE",
  authDomain: "traderelax-c0662.firebaseapp.com",
  projectId: "traderelax-c0662",
  storageBucket: "traderelax-c0662.firebasestorage.app",
  messagingSenderId: "597665401829",
  appId: "1:597665401829:web:17d0e84993c0975e0fbd0c"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
let messaging = null;

// Only initialize messaging if supported
if (typeof window !== 'undefined' && 'Notification' in window) {
  try {
    messaging = getMessaging(app);
  } catch (error) {
    console.log('Firebase messaging not supported:', error);
  }
}

export { app, messaging, getToken, onMessage };
export default app;
